import type { ApiUpdateLastGamesPort } from '~/handlers/ports/api-update-last-games.port';
import type {
  LastGamesPostPayload,
  LastGamesPostResponse,
} from '~/types/last-game';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';
import { getApostatudoRequestHeaders } from '~/utils/apostatudo/get-apostatudo-request-headers';

export class ApostatudoApiUpdateLastGamesAdapter
  implements ApiUpdateLastGamesPort
{
  async handle(
    payload: LastGamesPostPayload,
  ): Promise<LastGamesPostResponse | null> {
    try {
      // Timeout de 5 segundos para não travar nada
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000);

      const response = await fetch(`${getApostatudoApiUrl()}/last-games`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          ...getApostatudoRequestHeaders(),
        },
        body: JSON.stringify(payload),
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        return null;
      }

      const data: LastGamesPostResponse = await response.json();

      return data;
    } catch {
      return null;
    }
  }
}
